import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { MiDetailFields } from "@miplatform/components";
import { INPUT_TYPES } from "@miplatform/constants";
import { ConfigAccordionHeader } from "../../../../../../Config/components/ConfigAccordionHeader/ConfigAccordionHeader";
import { IDropTypeData } from "../../../DropTypes.types";

export const DropTypeDetailsTab: FC<DropTypeDetailsTabProps> = ({ form }) => {
  const { control } = form;

  const dropTypeDetailFields = [
    {
      label: "Drop Type Name",
      name: "name",
      fieldType: INPUT_TYPES.TEXTBOX,
      formControl: control,
      InputProps: { inputProps: { maxLength: 64 } },
      required: true,
    },
  ];

  return (
    <ConfigAccordionHeader title="Enter Drop Type Details">
      <MiDetailFields
        detailFields={dropTypeDetailFields}
        headerProps={{
          subtitle: "Enter drop type details below.",
          variant: "text",
        }}
      />
    </ConfigAccordionHeader>
  );
};

interface DropTypeDetailsTabProps {
  form: UseFormReturn<IDropTypeData>;
}
